import type { StompClient } from "@/components/realtime/stom-client.ts";

import { createContext } from "@/hooks/contexts.ts";

export interface IStompContext {
  stompClient: StompClient;
}

export const StompContext = createContext<IStompContext>({
  stompClient: null as never,
});
